export default function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid var(--border)',
      padding: '3rem 2rem',
    }}>
      <div className="page-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1.5rem' }}>
        <div>
          <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1.25rem', color: 'var(--white)' }}>
            P.<span style={{ color: 'var(--gold)' }}>K</span>
          </span>
        </div>
        <p style={{ margin: 0, color: 'var(--muted)', fontSize: '0.8rem' }}>
          © {new Date().getFullYear()} Sirigirisetty Pradeep Kumar &nbsp;·&nbsp; Built with React & GSAP
        </p>
        <div style={{ display: 'flex', gap: '1.5rem' }}>
          {[
            { label: 'GitHub', href: 'https://github.com/Pradeepkumarsirigirisetty' },
            { label: 'LinkedIn', href: 'https://www.linkedin.com/in/sirigirisetty-pradeep-kumar-218591340/' },
            { label: 'Email', href: 'mailto:pradeepkumarsirigirisetty@gmail.com' },
          ].map(l => (
            <a key={l.label} href={l.href} target={l.href.startsWith('http') ? '_blank' : undefined} rel="noreferrer"
              className="nav-item">{l.label}</a>
          ))}
        </div>
      </div>
    </footer>
  );
}
